import mPlayerWrapper, {
  PlayerListener,
  Animation,
} from 'spine-player/spine-player-wrapper';

import img_bg from 'assets/images/bg.min.jpg';
import img_bg_mobile from 'assets/images/bg_m.min.jpg';
import board from 'assets/images/board.min.png';
import side_bar_bottom from 'assets/images/side_bar_bottom.min.png';
import side_bar_top from 'assets/images/side_bar_top.min.png';
import img_explosion from 'assets/images/explosion.min.png';
import img_dynamite from 'assets/images/mine.min.png';
import img_opengold from 'assets/images/prize.min.png';
import t1 from 'assets/images/t1.min.png';
import t2 from 'assets/images/t2.min.png';
import img_bn_badge from 'assets/icons/bonus_label.min.png';
import sound_button_enable from 'assets/sounds/button_enable.mp3';
import sound_button_hover from 'assets/sounds/button_hover.mp3';
import sound_dynamite_explosion from 'assets/sounds/dynamite_explosion.mp3';
import sound_falling_stones from 'assets/sounds/falling_stones.mp3';
import sound_game_starter from 'assets/sounds/game_starter.mp3';
import sound_gold_reveal from 'assets/sounds/gold_reveal.mp3';
import sound_stone_click from 'assets/sounds/stone_click.mp3';
import sound_stone_hover from 'assets/sounds/stone_hover.mp3';
import sound_stone_shake from 'assets/sounds/stone_shake.mp3';
import sound_win from 'assets/sounds/win.mp3';
import character_lose from 'assets/sounds/character_lose.mp3';
import character_win_1 from 'assets/sounds/character_win_1.mp3';
import character_win_2 from 'assets/sounds/character_win_2.mp3';
import character_win_3 from 'assets/sounds/character_win_3.mp3';
import character_node from 'assets/sounds/character_nod.mp3';

import { TFiles } from './types';

const bg = window.matchMedia('(max-width: 800px)').matches
  ? img_bg_mobile
  : img_bg;

export const files: TFiles = {
  image: [
    bg,
    board,
    side_bar_bottom,
    side_bar_top,
    img_dynamite,
    img_opengold,
    t1,
    t2,
    img_bn_badge,
  ],
  imageToBlob: [img_explosion],
  fetch: [
    sound_button_enable,
    sound_button_hover,
    sound_dynamite_explosion,
    sound_falling_stones,
    sound_game_starter,
    sound_gold_reveal,
    sound_stone_click,
    sound_stone_hover,
    sound_stone_shake,
    sound_win,
    character_lose,
    character_win_1,
    character_win_2,
    character_win_3,
    character_node,
  ],
  callback: [
    cb => {
      setTimeout(() => {
        cb();
      }, 1000);
    },
    cb => {
      const listener: PlayerListener = {
        onReady() {
          mPlayerWrapper.unsubscribeListener(listener);
          cb();
        },

        onAnimationStart(animation: Animation) {},
      };

      mPlayerWrapper.subscribeListener(listener);
    },
  ],
};
